import store from '@/store';

import getValueByFieldName from '@/forms/helpers/get-value-by-field-name';
import { otpRepository } from '@/forms/api/repository-factory';
import { SET_SERVICE_STATUS_REFERAL } from '@/lib/constants/mutations';
import checkServiceStatus from '@/lib/helpers/check-service-status-referal';
import FIELD_NAMES from '@/forms/constants/field-names';
import { SET_PROMO_CODE_RESPONSE, SET_PROMO_CODE_STATUS } from '@/lib/constants/mutations';
import callApiPromo from '@/lib/helpers/call-api-promo';

import {
    OTP_VALIDATE_REFERAL,
    SERVICE_STATUS_REFRAL,
  
  } from '@/forms/constants/services';
// const getPayload = () => {
//   const { appId } = store.state;
//   const { values } = store.state.formData;
//   const promoCode = getValueByFieldName(values, FIELD_NAMES.promoCodeInput);

//   return {
//     "PromoCode": promoCode,

//   };
// };

const otpIsValid = () => checkServiceStatus(OTP_VALIDATE_REFERAL) === SERVICE_STATUS_REFRAL.success;

export default {
    sendOtp: async (currentStep, callbacks) => {
        const { form } = currentStep;
        const { values } = store.state.formData;
        const { appId,agentMobileNumber } = store.state;
    
        const response = await callApiPromo({
          callbacks,
          form,
        formElement: currentStep,
          apiCallPromo: otpRepository.sendOtpCodeV2,
          payload: agentMobileNumber,
        });
    
        return !!response;
      },
      sendOtpCustomer:async (currentStep, callbacks) => {
        const { form } = currentStep;
        const { values } = store.state.formData;
        const { appId,agentMobileNumber } = store.state;
        const customerMobileNumber = getValueByFieldName(values, FIELD_NAMES.phoneNumber)
        var appid =  appId+',';
        const response = await callApiPromo({
          callbacks,
          form,
        formElement: currentStep,
          apiCallPromo: otpRepository.sendOtpCodeV3,
          payload: appid+customerMobileNumber,
        });
    
        return !!response;
      },
      resendOtpCustomer: async () => {

       // const { form } = currentStep;
        const { values } = store.state.formData;
        const { appId,agentMobileNumber } = store.state;
        const customerMobileNumber = getValueByFieldName(values, FIELD_NAMES.phoneNumber)
        var appid=','+appId
        const response = await otpRepository.sendOtpCodeV3(customerMobileNumber);
    
        return !!response;
      },
      validateAndBlockFieldsCustomer: async (step, callbacks) => {
        var path = window.location.href;
        const { appId,agentMobileNumber, formData: { values } } = store.state;
        const customerMobileNumber = getValueByFieldName(values, FIELD_NAMES.phoneNumber)
        const { form } = step;
        if (otpIsValid()) {
          return true;
        }
        let otpCode;
        if(customerMobileNumber)
        {
            otpCode= values[FIELD_NAMES.OTPCode]
        }
        else
        {
         otpCode=   values[FIELD_NAMES.otpInput]
        }
        const response = await callApiPromo({
          callbacks,
          form,
          formElement: step,
          apiCallPromo: otpRepository.validateOtpCodeV3,
          payload: {
            "target":customerMobileNumber,
            "otp": otpCode,
            
          },
        });
    
        if (response.validation_status) {
          if (response.validation_status.toUpperCase() === 'SUCCESS') {
            store.commit(SET_SERVICE_STATUS_REFERAL, {
                servicesReferal: OTP_VALIDATE_REFERAL,
              statusReferal: SERVICE_STATUS_REFRAL.success,
            });
            return true;
          }
          store.commit(SET_SERVICE_STATUS_REFERAL, {
            service: OTP_VALIDATE_REFERAL,
            status: SERVICE_STATUS_REFRAL.fail,
          });
        }
    
    
        return false;
      },
      validateAndBlockCustomerConsent: async (step, callbacks) => {
        var path = window.location.href;
        const { appId, agentMobileNumber, formData: { values } } = store.state;
        const customerMobileNumber = getValueByFieldName(values, FIELD_NAMES.phoneNumber)
        const { form } = step;
        if (otpIsValid()) {
          return true;
        }
        let otpCode;
        if (customerMobileNumber) {
          otpCode = values[FIELD_NAMES.OTPCode]
        }
        else {
          otpCode = values[FIELD_NAMES.otpInput]
        }
        let response = false;
         response = await callApiPromo({
          callbacks,
          form,
          formElement: step,
          apiCallPromo: otpRepository.validateChekV3,
          payload: {
            "app-id":appId
    
          },
        });
    
        if (response) {
          const stauts=response['otp-status'].toUpperCase();
          return stauts.toUpperCase()==='SUCCESS';
        }
        //return response;
      },
      validateAndBlockFields: async (step, callbacks) => {
        var path = window.location.href;
        const { appId,agentMobileNumber, formData: { values } } = store.state;
        const { form } = step;
        if (otpIsValid()) {
          return true;
        }
        let otpCode;
        if(path.includes('nbc/loan'))
        {
            otpCode= values[FIELD_NAMES.OTPCode]
        }
        else
        {
         otpCode=   values[FIELD_NAMES.otpInput]
        }
        const response = await callApiPromo({
          callbacks,
          form,
          formElement: step,
          apiCallPromo: otpRepository.validateOtpCodeV2,
          payload: {
            "target":agentMobileNumber,
            "otp": otpCode,
            
          },
        });
    
        if (response.validation_status) {
          if (response.validation_status.toUpperCase() === 'SUCCESS') {
            store.commit(SET_SERVICE_STATUS_REFERAL, {
                servicesReferal: OTP_VALIDATE_REFERAL,
              statusReferal: SERVICE_STATUS_REFRAL.success,
            });
            return true;
          }
          store.commit(SET_SERVICE_STATUS_REFERAL, {
            service: OTP_VALIDATE_REFERAL,
            status: SERVICE_STATUS_REFRAL.fail,
          });
        }
    
    
        return false;
      },
};
